module.exports = __webpack_public_path__ + "img/Elderberry.c80fc6b7.png";